import { message, Skeleton, Spin } from "antd";
import { StatusCode, UserRoles } from "common/enums";
import socket from "config/api.socket";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useGetPostsQuery } from "store/services/teacher/activities.services";
import CardActivities from "./components/card";
import MainContentTop from "./components/mainContentTop";
import s from "./style.module.css";

import * as TEACHER_SERVICES from "../../../../../api/services/teacher/teacher.services";

interface Props { }

interface MainContentProps {
  onAddPost: () => void;
  handleAddDocs: (param: any) => void;
}

const MainContent: React.FC<MainContentProps> = ({ onAddPost, handleAddDocs }) => {

  const { user } = useSelector((state) => state.auth);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const { data, isLoading, isError, refetch } = useGetPostsQuery(user?._id);
  const [allData, setAllData] = useState<any[]>([]);
  const isStudent = user?.roles?.includes(UserRoles.STUDENT);
  const isTeacher = user?.roles?.includes(UserRoles.TEACHER);

  const [isEditingPost, setIsEditingPost] = useState<boolean>(false);
  const [isPostDeleted, setIsPostDeleted] = useState<boolean>(false);
  const [isLoadingMore, setIsLoadingMore] = useState<boolean>(false);
  const [articleEditing, setArtcileEditing] = useState<any>();

  const loadMoreRef = useRef<HTMLDivElement | null>(null);

  const fetchMorePosts = async () => {
    try {
      setIsLoadingMore(true);
      const response = await TEACHER_SERVICES.getMorePosts(user?._id, currentPage);
      if (response?.statusCode === StatusCode.OK) {
        setAllData((prevData: any[]) => [...prevData, ...response?.data.results]);
      }
    }
    catch (error: any) {
      message.warning({ content: error?.response?.data?.message })
    }
    finally {
      setIsLoadingMore(false);
    }
  };

  useEffect(() => {
    if (data?.data?.results) {
      setAllData(data.data.results);
    }
  }, [data, refetch]);

  useEffect(() => {
    socket?.on("connect", () => {
      console.log("Socket connected!");
    });

    socket?.on("newPost", (postData: any) => {
      //setAllData((prevData: any[]) => [...prevData, postData.post.post]); 
      refetch();
    });

    return () => {
      socket?.off("newPost");
    };
  }, [socket, data, refetch]);

  useEffect(() => {
    refetch();
  }, [isPostDeleted]);

  useEffect(() => {
    console.log(currentPage);
    if (currentPage > 1) {
      fetchMorePosts();
    }
  }, [currentPage]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isLoadingMore && data?.data?.totalPages > currentPage) {
          setCurrentPage((prev) => prev + 1);
        }
      },
      { threshold: 1.0 } // fully visible before triggering
    );

    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current);
    }

    return () => observer.disconnect();
  }, [isLoadingMore, currentPage, data]);

  return (
    <div className={s.mainContent}>
      {user?.roles.includes("teacher") && user?.isActive && user?.step === "completed" && <MainContentTop onAddPostTop={onAddPost} handleAddDocsTop={handleAddDocs} isEditingPost={isEditingPost} articleEditing={articleEditing} setIsEditingPost={setIsEditingPost} />}

      {isLoading ? (
        <>
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </>
      ) : (
        <div style={{ marginTop: isStudent || (isTeacher && !user?.isActive) ? "0px" : "20px" }}>
          {allData?.map((info: any, index: number) => (
            <CardActivities key={info._id} info={info} setIsPostDeleted={setIsPostDeleted} setIsEditingPost={setIsEditingPost} setArtcileEditing={setArtcileEditing} />
          ))}
        </div>
      )}
      <div ref={loadMoreRef} style={{ height: 60, display: "flex", justifyContent: "center", alignItems: "center" }}>
        {isLoadingMore && <Spin size="large" />}
      </div>
    </div>
  );
};

export default MainContent;
